import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { setAuthToken } from "@/_reducers/accounts.reducer";

const LoadAuthToken = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const loadToken = async () => {
      const token: string | null = await AsyncStorage.getItem("token");

      dispatch(setAuthToken(token));
    };

    loadToken();
  }, [dispatch]);

  return null;
};

export default LoadAuthToken;
